import { Box, Button, Modal, TextField, Typography } from "@mui/material";
import {
  MainContainerModal,
  MainContainerWrapper,
} from "../../../styles/Main.styles";
import { useGetCustomerType } from "../../produk/network/resolver";
import {
  IOptions,
  InputAutocompleteOptions,
  InputSelect,
} from "../../../components/input/input";
import { useCallback, useEffect, useState } from "react";
import { AutoCompleteSelect } from "../../../components/input/input";
import { useToast } from "../../../context/toast/ToastContext";
import { LoadingButton } from "../../../components/button/Button";
import {
  useAktualisasiInvoice,
  useGetDetailInvoice,
} from "../network/resolver";
import { ToMoneyFormat } from "../../../utils/Helper";
import { IInvoiceData } from "../Invoice.type";
import ProductPrice from "./ProductPrice";
import { STATUS_INVOICE_OPTIONS } from "./SelectStatusInvoice";
import SelectPrintType from "./SelectPrintType";
import { IAddedProduct } from "../hooks/SubmitInvoice";
import Spinner from "../../../components/spinner/Spinner";
import { useNavigate } from "react-router";

interface IModalInvoice {
  visible: boolean;
  invoice?: IInvoiceData;
  idInvoice?: number;
  idInvoiceParam?: number;
  invoicePrintOptions: IOptions[];
  isAdd?: boolean;
  isPreOrder?: boolean;
  isPlacedOrder?: boolean;
  hidePrint?: boolean;
  onClose(): void;
}

export default function ModalInvoice({
  visible,
  invoice,
  idInvoice,
  idInvoiceParam,
  invoicePrintOptions,
  isAdd,
  isPlacedOrder,
  hidePrint,
  onClose,
}: IModalInvoice) {
  const navigate = useNavigate();
  const toast = useToast();
  const [dataCustomerTypeOptions, setDataCustomerTypeOptions] = useState<
    InputAutocompleteOptions[]
  >([]);
  const [selectedCustomerType, setSelectedCustomerType] =
    useState<InputAutocompleteOptions | null>(null);
  const [listAddedProduct, setListAddedProduct] = useState<IAddedProduct[]>([]);
  const [namaToko, setNamaToko] = useState("");
  const [namaCustomer, setNamaCustomer] = useState("");
  const [tax, setTax] = useState(0);
  const [pph, setPph] = useState(0);
  const [invoiceNumber, setInvoiceNumber] = useState<number>();
  const [invoiceType] = useState<IOptions>(STATUS_INVOICE_OPTIONS[0]);
  const [invoiceTypeDetail, setInvoiceTypeDetail] = useState<IOptions | null>(
    null
  );
  const [isEditable, setIsEditable] = useState(false);
  const { data: dataRawInvoice } = useGetDetailInvoice({
    invoice_id: idInvoice,
  });
  const dataInvoice = dataRawInvoice?.data?.data;
  const { data: dataRawCustomerType, isLoading: loadingCustomerType } =
    useGetCustomerType({});
  const dataCustomerType = dataRawCustomerType?.data?.data?.data;
  // const { addInvoice, updateStatus, splitInvoice, loading } =
  //   useSubmitInvoice();
  // const isTicketOrPreOrder =
  //   invoice?.status === 1 || invoice?.status == 2 || !invoice;
  const { mutateAsync: mutate, isLoading } = useAktualisasiInvoice();
  const shouldDisabled = dataInvoice?.status === 4 || dataInvoice?.status === 3;

  useEffect(() => {
    if (dataCustomerType) {
      const temp: InputAutocompleteOptions[] = [];
      dataCustomerType.forEach((item) => {
        temp.push({
          id: item.id,
          label: item.customer_type_name,
        });
      });
      setDataCustomerTypeOptions(temp);
    }
  }, [dataCustomerType]);

  useEffect(() => {
    setNamaToko(dataInvoice?.shop_name || "");
    setNamaCustomer(dataInvoice?.customer_name || "");
    setTax(dataInvoice?.tax_percentage || 0);
    setPph(dataInvoice?.pph_percentage || 0);
    const temp: IAddedProduct[] = [];
    dataInvoice?.invoice_detail.map((item) => {
      temp.push({
        name: item.product.name,
        price: item.price,
        product_id: item.product_id,
        quantity: item.quantity,
      });
    });
    setListAddedProduct(temp);
    //
    switch (dataInvoice?.invoice_type) {
      case 1:
        setInvoiceTypeDetail({ text: "Resmi", value: 1 });
        break;
      case 2:
        setInvoiceTypeDetail({ text: "Tidak Resmi", value: 2 });
        break;
      case 3:
        setInvoiceTypeDetail({ text: "Resmi Berikat", value: 3 });
        break;
    }
  }, [dataInvoice]);

  useEffect(() => {
    if (dataInvoice && !loadingCustomerType) {
      const target = dataCustomerTypeOptions.filter(
        (item) => item.id === dataInvoice.customer_type_id
      );
      setSelectedCustomerType(target[0]);
    }
  }, [dataCustomerTypeOptions, dataInvoice, loadingCustomerType]);

  const callbackTotalRp = useCallback(() => {
    let temp = 0;
    listAddedProduct.forEach((item) => {
      if (item.quantity) {
        temp += item.price * item.quantity;
      }
    });
    return Math.floor(temp);
  }, [listAddedProduct]);

  const callbackTotalTax = useCallback(() => {
    let temp = 0;
    listAddedProduct.forEach((item) => {
      if (item.quantity) {
        temp += item.price * item.quantity;
      }
    });
    return Math.floor(temp * (tax / 100));
  }, [listAddedProduct, tax]);

  const calculateGrandTotal = () => {
    let total = callbackTotalRp();
    const totalWithPph = Math.floor(total - total * (pph / 100));
    const temp = Math.floor(total - totalWithPph);
    return {
      total: totalWithPph,
      pph: temp,
    };
  };

  async function handleSubmit() {
    if (listAddedProduct && idInvoice && invoiceTypeDetail) {
      const temp = listAddedProduct.map((item) => {
        return {
          invoice_detail_id: item.idDetail,
          quantity: item.quantity,
          price: item.price,
        };
      });
      await mutate({
        invoice_id: idInvoice,
        invoice_type: invoiceTypeDetail.value,
        invoice_detail: JSON.stringify(temp),
      });
    }
    onClose();
  }

  if (loadingCustomerType) {
    return idInvoiceParam ? <Spinner /> : null;
  }

  return (
    <Modal
      style={{ height: "100%" }}
      open={visible}
      onClose={() => {
        if (idInvoiceParam) {
          navigate("/invoice/pre-order");
        }
        onClose();
      }}
    >
      <MainContainerModal>
        <MainContainerWrapper>
          <div>
            <Box display={"flex"} justifyContent={"space-between"} pb={2}>
              <Box>
                <Typography variant="h6" fontWeight={"bold"}>
                  Nomor Invoice
                </Typography>
                <Typography variant="subtitle1">
                  {dataInvoice?.invoice_number}
                </Typography>
              </Box>
              <Box>
                <Typography variant="h6" fontWeight={"bold"}>
                  Nomor PO
                </Typography>
                <Typography variant="subtitle1">
                  {dataInvoice?.pre_order_number}
                </Typography>
              </Box>
              <Button
                style={{ height: 50 }}
                variant="contained"
                color={!isEditable ? "warning" : "inherit"}
                onClick={() => setIsEditable((prev) => !prev)}
              >
                Aktualisasi nota
              </Button>
            </Box>

            {dataInvoice && (
              <Box marginTop={3}>
                <SelectPrintType
                  invoice={dataInvoice}
                  invoicePrintOptions={invoicePrintOptions}
                />
              </Box>
            )}
            <Box marginTop={2}>
              {dataInvoice?.status === 3 ? (
                <TextField
                  type="number"
                  label="Nomor Invoice (Max: 4 Karakter)"
                  placeholder="Nomor Invoice"
                  value={invoiceNumber}
                  onChange={(e) => {
                    const temp = e.target.value;
                    if (temp.length <= 4) {
                      setInvoiceNumber(parseInt(e.target.value));
                    }
                  }}
                  fullWidth
                />
              ) : null}
            </Box>
            <Box marginTop={3}>
              <AutoCompleteSelect
                label="Tipe Customer"
                options={dataCustomerTypeOptions}
                value={selectedCustomerType}
                onChange={(e) => setSelectedCustomerType(e)}
                disabled={shouldDisabled}
              />
            </Box>
            <Box marginTop={2}>
              {(invoiceTypeDetail?.value || isEditable) && (
                <InputSelect
                  id={"invoice-type"}
                  label="Tipe Invoice"
                  options={[
                    { value: 1, text: "Resmi" },
                    { value: 2, text: "Tidak Resmi" },
                    { value: 3, text: "Resmi Berikat" },
                  ]}
                  value={invoiceTypeDetail?.value}
                  onChange={(e, v) => setInvoiceTypeDetail(v)}
                  disabled={!isEditable}
                />
              )}
            </Box>
            <Box marginTop={2}>
              <TextField
                label="Nama Toko"
                placeholder="Nama Toko"
                value={namaToko}
                onChange={(e) => setNamaToko(e.target.value)}
                fullWidth
                disabled={shouldDisabled}
              />
            </Box>
            <Box marginTop={2}>
              <TextField
                label="Nama Customer"
                placeholder="Nama Customer"
                value={namaCustomer}
                onChange={(e) => setNamaCustomer(e.target.value)}
                fullWidth
                disabled={shouldDisabled}
              />
            </Box>
            <Box marginTop={2}>
              <TextField
                label="Tax"
                placeholder="Tax"
                value={tax}
                onChange={(e) => {
                  const value = e.target.value ? parseInt(e.target.value) : 0;
                  setTax(value);
                }}
                fullWidth
                disabled={shouldDisabled}
              />
            </Box>
            <Box marginTop={2}>
              <TextField
                label="Pph"
                placeholder="Pph"
                value={pph}
                onChange={(e) => {
                  const value = e.target.value ? parseInt(e.target.value) : 0;
                  setPph(value);
                }}
                fullWidth
                disabled={shouldDisabled}
              />
            </Box>
            <ProductPrice
              editable={isEditable}
              isPlacedOrder={isPlacedOrder}
              isPreOrder={invoiceType.value === 2}
              isAdd={isAdd}
              invoice={dataInvoice}
              customerTypeId={selectedCustomerType?.id}
              onChange={(e) => {
                setListAddedProduct(e);
              }}
            />
            <Box
              marginTop={3}
              display={"flex"}
              alignItems={"flex-start"}
              flexDirection={"column"}
            >
              <Box marginTop={1} marginBottom={1}>
                <Typography variant="h6">
                  Tax :{" "}
                  {ToMoneyFormat(
                    isEditable ? callbackTotalTax() : dataInvoice?.tax
                  )}
                </Typography>
              </Box>
              <Box marginTop={1} marginBottom={1}>
                <Typography variant="h6">
                  Pph :{" "}
                  {ToMoneyFormat(
                    isEditable ? calculateGrandTotal().pph : dataInvoice?.pph
                  )}
                </Typography>
              </Box>
              <Box marginTop={1} marginBottom={1}>
                <Typography variant="h6">
                  DPP :{" "}
                  {ToMoneyFormat(
                    isEditable ? callbackTotalRp() : dataInvoice?.total
                  )}
                </Typography>
              </Box>
              <Box marginTop={1} marginBottom={1}>
                <Typography variant="h6">
                  Grand Total :{" "}
                  {ToMoneyFormat(
                    isEditable
                      ? calculateGrandTotal().total + callbackTotalTax()
                      : dataInvoice?.grand_total
                  )}
                </Typography>
              </Box>
            </Box>
            <Box display={"flex"} justifyContent={"flex-end"}>
              {isEditable && (
                <LoadingButton
                  text={"Update"}
                  isLoading={isLoading}
                  onClick={handleSubmit}
                />
              )}
            </Box>
          </div>
        </MainContainerWrapper>
      </MainContainerModal>
    </Modal>
  );
}
